import HubLayout from './HubLayout';
import { useCategories } from '../hooks/useCategories';

export default function SekerlikHub() {
  const { categories, loading } = useCategories('sekerlik');

  if (loading) {
    return (
      <main className="page hub-page">
        <p className="section-note" style={{ padding: '2rem 1rem' }}>Yükleniyor…</p>
      </main>
    );
  }

  return (
    <HubLayout
      title="Şekerlik modelleri"
      subtitle="Davetiyenizle uyumlu Eskişehir şekerlik modelleri: düğün, nişan, sünnet ve doğum ikram ambalajları."
      categories={categories}
      basePath="/sekerlik"
    />
  );
}
